var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Input, InputNumber, Modal, Switch, Table, message, Popconfirm, Tag, Alert, Drawer, } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined, CommentOutlined } from '@ant-design/icons';
import { useGetTogetherActivitiesAdminQuery, useCreateTogetherActivityMutation, useUpdateTogetherActivityMutation, useDeleteTogetherActivityMutation, } from '@/services/togetherActivityApi';
import { useGetExternalChatsByTogetherActivityIdQuery } from '@/services/chatsApi';
import './TogetherActivityControlPage.scss';
var TogetherActivityControlPage = function () {
    var _a;
    var navigate = useNavigate();
    var _b = useGetTogetherActivitiesAdminQuery(), data = _b.data, isLoading = _b.isLoading, isError = _b.isError, error = _b.error, refetch = _b.refetch, isFetching = _b.isFetching;
    var _c = useCreateTogetherActivityMutation(), createActivity = _c[0], creating = _c[1].isLoading;
    var _d = useUpdateTogetherActivityMutation(), updateActivity = _d[0], updating = _d[1].isLoading;
    var deleteActivity = useDeleteTogetherActivityMutation()[0];
    var _e = useState(false), modalOpen = _e[0], setModalOpen = _e[1];
    var _f = useState(null), editing = _f[0], setEditing = _f[1];
    var _g = useState(null), chatsForActivity = _g[0], setChatsForActivity = _g[1];
    var form = Form.useForm()[0];
    var _h = useGetExternalChatsByTogetherActivityIdQuery({ activityId: (_a = chatsForActivity === null || chatsForActivity === void 0 ? void 0 : chatsForActivity.id) !== null && _a !== void 0 ? _a : 0 }, { skip: !chatsForActivity }), activityChats = _h.data, chatsLoading = _h.isLoading;
    var openCreate = function () {
        setEditing(null);
        form.resetFields();
        form.setFieldsValue({ sortOrder: 0, isActive: true });
        setModalOpen(true);
    };
    var openEdit = function (row) {
        setEditing(row);
        form.setFieldsValue({
            title: row.title,
            sortOrder: row.sortOrder,
            isActive: row.isActive,
        });
        setModalOpen(true);
    };
    var handleSubmit = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var values, e_1, err, msg;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, form.validateFields()];
                    case 1:
                        values = _c.sent();
                        if (!editing)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, updateActivity({
                                id: editing.id,
                                data: {
                                    title: values.title,
                                    sortOrder: values.sortOrder,
                                    isActive: values.isActive,
                                },
                            }).unwrap()];
                    case 2:
                        _c.sent();
                        message.success('Сохранено');
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, createActivity({
                            title: values.title,
                            sortOrder: values.sortOrder,
                            isActive: values.isActive,
                        }).unwrap()];
                    case 4:
                        _c.sent();
                        message.success('Добавлено');
                        _c.label = 5;
                    case 5:
                        setModalOpen(false);
                        refetch();
                        return [3 /*break*/, 7];
                    case 6:
                        e_1 = _c.sent();
                        console.error(e_1);
                        err = e_1;
                        msg = typeof ((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) === 'string'
                            ? err.data.message
                            : Array.isArray((_b = err === null || err === void 0 ? void 0 : err.data) === null || _b === void 0 ? void 0 : _b.message)
                                ? err.data.message.join(', ')
                                : 'Не удалось сохранить';
                        message.error(msg);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    var handleDelete = function (id) {
        return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, deleteActivity(id).unwrap()];
                    case 1:
                        _b.sent();
                        message.success('Удалено');
                        refetch();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        message.error('Ошибка удаления');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var errorDetail = isError && error && 'data' in error && error.data && typeof error.data === 'object' && 'message' in error.data
        ? String(error.data.message)
        : isError
            ? 'Проверьте, что API запущен и миграции применены.'
            : '';
    return (_jsxs("div", __assign({ className: "TogetherActivityControlPage" }, { children: [_jsxs("div", __assign({ className: "titleBlock" }, { children: [_jsx("h1", { children: "\u0425\u043E\u0447\u0443 \u0432\u043C\u0435\u0441\u0442\u0435" }), _jsx(Button, __assign({ type: "primary", icon: _jsx(PlusOutlined, {}), onClick: openCreate }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435" }))] })), _jsxs("div", __assign({ className: "TogetherActivityControlPage__content" }, { children: [isError && (_jsx(Alert, { type: "error", showIcon: true, style: { marginBottom: 16 }, message: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A", description: errorDetail, action: _jsx(Button, __assign({ size: "small", icon: _jsx(ReloadOutlined, {}), onClick: function () { return refetch(); } }, { children: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C" })) })), _jsx("div", __assign({ className: "TogetherActivityControlPage__card" }, { children: _jsx(Table, { rowKey: "id", loading: isLoading || isFetching, dataSource: data !== null && data !== void 0 ? data : [], pagination: false, bordered: true, size: "middle", locale: {
                                emptyText: isError
                                    ? 'Нет данных — ошибка загрузки'
                                    : 'Пока нет действий. Нажмите «Добавить действие», чтобы создать первую строку.',
                            }, columns: [
                                {
                                    title: 'Название',
                                    dataIndex: 'title',
                                    key: 'title',
                                    ellipsis: true,
                                },
                                {
                                    title: 'Отметок (♥)',
                                    dataIndex: 'likesCount',
                                    width: 130,
                                    align: 'center',
                                    key: 'likesCount',
                                    sorter: function (a, b) {
                                        return a.likesCount - b.likesCount;
                                    },
                                    defaultSortOrder: 'descend',
                                },
                                {
                                    title: 'Порядок при равенстве',
                                    dataIndex: 'sortOrder',
                                    width: 150,
                                    key: 'sortOrder',
                                    align: 'center',
                                },
                                {
                                    title: 'Активно',
                                    dataIndex: 'isActive',
                                    width: 110,
                                    align: 'center',
                                    render: function (v) { return (v ? _jsx(Tag, __assign({ color: "green" }, { children: "\u0434\u0430" })) : _jsx(Tag, { children: "\u043D\u0435\u0442" })); },
                                },
                                {
                                    title: 'Действия',
                                    key: 'actions',
                                    width: 200,
                                    align: 'center',
                                    render: function (_, row) { return (_jsxs(_Fragment, { children: [_jsx(Button, { type: "text", icon: _jsx(CommentOutlined, {}), onClick: function () { return setChatsForActivity(row); }, "aria-label": "\u0427\u0430\u0442\u044B \u043F\u043E \u044D\u0442\u043E\u043C\u0443 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044E" }), _jsx(Button, { type: "text", icon: _jsx(EditOutlined, {}), onClick: function () { return openEdit(row); }, "aria-label": "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C" }), _jsx(Popconfirm, __assign({ title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435?", onConfirm: function () { return handleDelete(row.id); }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" }, { children: _jsx(Button, { type: "text", danger: true, icon: _jsx(DeleteOutlined, {}), "aria-label": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }) }))] })); },
                                },
                            ] }) }))] })), _jsx(Modal, __assign({ title: editing ? 'Редактировать действие' : 'Новое действие', open: modalOpen, onCancel: function () { return setModalOpen(false); }, onOk: handleSubmit, confirmLoading: creating || updating, destroyOnClose: true, okText: editing ? 'Сохранить' : 'Создать', cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430" }, { children: _jsxs(Form, __assign({ form: form, layout: "vertical" }, { children: [_jsx(Form.Item, __assign({ name: "title", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", rules: [{ required: true, message: 'Введите название' }] }, { children: _jsx(Input, { placeholder: "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440: \u041F\u0440\u043E\u0433\u0443\u043B\u043A\u0430 \u043F\u043E \u043D\u0430\u0431\u0435\u0440\u0435\u0436\u043D\u043E\u0439" }) })), _jsx(Form.Item, __assign({ name: "sortOrder", label: "\u041F\u043E\u0440\u044F\u0434\u043E\u043A \u043F\u0440\u0438 \u043E\u0434\u0438\u043D\u0430\u043A\u043E\u0432\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u043E\u0442\u043C\u0435\u0442\u043E\u043A", extra: "\u0412 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0441\u043F\u0438\u0441\u043E\u043A \u0441\u043E\u0440\u0442\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u043F\u043E \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u043E\u0441\u0442\u0438 (\u043E\u0442\u043C\u0435\u0442\u043A\u0438). \u042D\u0442\u043E \u043F\u043E\u043B\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F, \u0435\u0441\u043B\u0438 \u0443 \u0434\u0432\u0443\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u043E\u0434\u0438\u043D\u0430\u043A\u043E\u0432\u043E\u0435 \u0447\u0438\u0441\u043B\u043E \u043E\u0442\u043C\u0435\u0442\u043E\u043A \u2014 \u043C\u0435\u043D\u044C\u0448\u0435\u0435 \u0447\u0438\u0441\u043B\u043E \u0432\u044B\u0448\u0435.", rules: [{ required: true }] }, { children: _jsx(InputNumber, { min: 0, style: { width: '100%' } }) })), _jsx(Form.Item, __assign({ name: "isActive", label: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438", valuePropName: "checked" }, { children: _jsx(Switch, {}) }))] })) })), _jsx(Drawer, __assign({ title: chatsForActivity ? "\u0427\u0430\u0442\u044B: \u00AB".concat(chatsForActivity.title, "\u00BB") : 'Чаты', placement: "right", width: 520, open: !!chatsForActivity, onClose: function () { return setChatsForActivity(null); } }, { children: _jsx(Table, { rowKey: "id", size: "small", loading: chatsLoading, dataSource: activityChats !== null && activityChats !== void 0 ? activityChats : [], pagination: false, locale: { emptyText: 'Пока нет чатов по этому действию' }, columns: [
                        { title: 'ID чата', dataIndex: 'id', width: 90 },
                        {
                            title: 'Участники',
                            key: 'participants',
                            render: function (_, chat) {
                                return (chat.participants || [])
                                    .map(function (p) { return p.fullName || p.login || p; })
                                    .join(', ') || '—';
                            },
                        },
                        {
                            title: '',
                            key: 'open',
                            width: 120,
                            render: function (_, chat) {
                                return (_jsx(Button, __assign({ type: "link", onClick: function () {
                                        var _a;
                                        return navigate("/chats/".concat(chat.id, "?external=1&togetherActivityId=").concat((_a = chatsForActivity === null || chatsForActivity === void 0 ? void 0 : chatsForActivity.id) !== null && _a !== void 0 ? _a : ""));
                                    } }, { children: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0447\u0430\u0442" })));
                            },
                        },
                    ] }) }))] })));
};
export default TogetherActivityControlPage;
